module.exports = __webpack_public_path__ + "resources/images/dashboard_old-e0f999053d800133aebcbc3c28dffff5-cache.png";